import { useParams } from "react-router-dom";
import { isTaskSaleAdditional } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import { PromoCatalogPage } from "@/pages/WorkPlan/Tasks/PromoCatalog/PromoCatalogPage";
import NotFound from "@/routes/Pages/NotFound";

const PromoCatalog = () => {
    const { id: marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];

    if (!currentTask || !isTaskSaleAdditional(currentTask)) return <NotFound />;

    return <PromoCatalogPage marketId={safeMarketId} task={currentTask} />;
};

export default PromoCatalog;
